// Module
var code = "<th ng-repeat=\"column in tableOptions.columns\" name=header data-value={{column.header}} ng-hide={{::column.hide}} ng-style=\"{'width': column.width, 'min-width': column.minWidth}\"> <div nlg-template=createTemplate(column) nlg-template-scope=this></div> </th>";
// Exports
module.exports = code;